import React, { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toastObj, setToastObj] = useState({ open: false, type: null, message: null });

  const handleToastOpen = (type, message) => {
    setToastObj({ open: true, type: type, message: message });
  };

  const handleToastClose = () => {
    setToastObj({ open: false });
  };

  return (
    <ToastContext.Provider value={{ toastObj, handleToastOpen, handleToastClose }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};
